module.exports = __webpack_public_path__ + "img/grey-triangle-m.58864270.png";